import React from "react";
import Img from "../images/projectt.jpg";

const projects = [
  {
    id: 1,
    title: "Project One",
    description: "Description for project one",
    imgUrl: Img,
  },
  {
    id: 2,
    title: "Project Two",
    description: "Description for project two",
    imgUrl: Img,
  },
  {
    id: 3,
    title: "Project Three",
    description: "Description for project three",
    imgUrl: Img,
  },
];

function Portfolio() {
  return (
    <div className="container mx-auto py-16 pt-40">
      <h2 className="text-3xl font-bold text-center mb-8">Our Portfolio</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {projects.map((project) => (
          <div key={project.id} className="bg-white p-6 rounded-lg shadow-lg">
            <img
              src={project.imgUrl}
              alt={project.title}
              className="mb-4 w-full h-40 object-cover rounded"
            />
            <h3 className="text-xl font-bold mb-2">{project.title}</h3>
            <p>{project.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Portfolio;
